<template>
  <div class="start-sign">
    <div class="scroll-content">
      <div class="wrapper">
        <div
          class="sign-content"
          ref="canvasBox"
        >
          <canvas class="canvasId" />
        </div>
        <div class="btns">
          <van-button
            type="default"
            class="clear"
            @click="clear"
            style="color: #0064dc"
          >重签</van-button>
          <van-button
            type="info"
            @click="doSave"
          >确定</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dataURLtoBlob } from '@/utils/exif';
import SignaturePad from 'signature_pad';
import UploadHelper from '@/common/upload-helper.js';
import { saveSurveyReport } from '@/common/api';

export default {
  name: 'StartSign',
  data() {
    return {
      SignaturePad: null,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(250,250,250)'
      },
      committed: false,
      loading: false,
      isFirst: true,
      imgURL: '',
      taskNo: ''
    };
  },
  mounted() {
    this.getCanvas();
    // 解决首次进入webview时，$router.go(-1)失效的问题
    if (this.isFirst) {
      const hash = location.hash;
      const state = {
        title: 'title',
        url: hash
      };
      window.history.pushState(state, 'title', hash);
      this.$router.go(-1);
      this.isFirst = false;
    }
  },
  async created() {
    if (this.$route.query.taskNo) {
      this.taskNo = this.$route.query.taskNo;
    }
  },
  methods: {
    getCanvas() {
      var canvas = document.querySelector('.canvasId');
      this.signaturePad = new SignaturePad(canvas, this.config);
      canvas.height = this.$refs.canvasBox.clientHeight;
      canvas.width = this.$refs.canvasBox.clientWidth;
    },
    clear() {
      this.signaturePad.clear();
    },
    doSave() {
      if (this.loading) return;
      this.loading = true;
      this.save().finally(() => {
        this.loading = false;
      });
    },
    async save() {
      if (this.signaturePad.isEmpty()) {
        return this.$toast('电子签名不能为空');
      }
      const png = this.signaturePad.toDataURL();
      const file = dataURLtoBlob(png);
      const currTime = new Date().getTime();
      file.name = currTime + '.png'; // 给图片命名
      const res = await UploadHelper(file);
      if (!res.accessUrl) {
        this.$toast('电子签名上传失败');
        return;
      }
      localStorage.setItem('operatorSignOssPath', res.accessUrl);
      localStorage.setItem('operatorSignPicId', res.picId);
      this.$toast('签名成功');
      this.$router.go(-1);

      //修复安卓手机返回不了，签名和订单管理不上的问题
      const params = { taskNo: this.taskNo, operatorSignOssPath: res.picId};
      try {
        await saveSurveyReport(params);
      } catch (error) {}
    },
  }
};
</script>

<style lang="scss" scoped>
.start-sign {
  .sign {
    position: relative;
  }

  .btns {
    padding-top: 30px;
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    box-shadow: inset 0 0.5px 0 0 rgba(230, 230, 230, 1);

    button {
      height: 36px;
      width: 160px;
      // padding: 12px 0;
      line-height: normal;
      font-size: 16px;
      border-radius: 24px;
      &:last-of-type {
        margin-left: 12px;
      }
      background: #4398ff;
    }
    .clear {
      border: 1px solid #999999;
      background: #ffffff;
      .van-button__text {
        color: #999999;
      }
    }
  }

  .singImg {
    display: block;
    width: 100%;
    height: calc(100vh - 30px - 50px) !important;
    border: 1px dashed #c4c4c4;
  }
  .wrapper {
    padding: 0 15px;
    padding-top: 20px;
    // padding-bottom: 100px;
  }

  .sign-content {
    // height: calc(100vh - 30px - 50px) !important;
    height: 150px;
    border: 1px dashed #c4c4c4;
    display: block;
  }
  .scroll-content {
    height: calc(100vh - 50px);
  }
}
</style>
